import { useAuth } from "../contexts/authContext";
import { doSignOut } from "../backend/auth";
import { useNavigate, Link } from "react-router-dom";

const Header = () => {
  const { userLoggedIn } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <div className="flex justify-between w-full text-sub bg-deco border-b-2 border-sub py-3 px-2.5 ">
        <div className="flex items-center text-center p-1">
          <Link to={"/"}>Quote Maker</Link>
        </div>

        <div className="flex h-10 text-xs">
          <div className="flex items-center bg-card p-1 border-2 border-sub mr-2 text-center">
            <Link to={"/profile"}>My Quotes</Link>
          </div>
          {userLoggedIn ? (
            <>
              <div className="flex items-center bg-card p-1 border-2 border-sub">
                <button
                  onClick={() => doSignOut().then(() => navigate("/login"))}
                >
                  Logout
                </button>
              </div>
            </>
          ) : (
            <div className="flex">
              <div className="flex items-center bg-card p-1 border-2 border-sub mr-2 text-center">
                <Link to={"/login"}>Login</Link>
              </div>
              <div className="flex items-center bg-card p-1 border-2 border-sub mr-2 text-center">
                <Link to={"/register"}>Register</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
